import api from 'api'
import { ICourseModel } from 'models/course.model'
import { ObjectToFormDataWithFiles, decamelizeThatDontBreaksFile } from 'helpers/converters.helper'

const createCourse = (course: ICourseModel) => {
  const decamelizeData = decamelizeThatDontBreaksFile(course)
  const formData = ObjectToFormDataWithFiles(decamelizeData, 'course')
  return api.post('administration/courses', formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
}

export default createCourse
